import React from 'react';
import classnames from 'classnames';
import { useTranslation } from 'react-i18next';
import CommentThread from '../../../CommentThread';
import ErrorBoundary from '../../../ErrorBoundary';
import DisabledComment from '../../../DisabledComment';
import { getCommentableTypeForDeviationType } from '../../redux/helpers';
import { BiLoggerContextProvider } from '../../../biLogger';
import s from './Comments.scss';
export var Comments = function (_a) {
    var currentUser = _a.currentUser, _b = _a.deviation, deviationId = _b.deviationId, typeId = _b.typeId, isCommentable = _b.isCommentable, className = _a.className;
    var t = useTranslation().t;
    var commentableTypeId = getCommentableTypeForDeviationType(typeId);
    return (React.createElement(ErrorBoundary, null,
        React.createElement(BiLoggerContextProvider, { value: { sectionname: 'comments' } },
            React.createElement("div", { id: "comments" }, isCommentable ? (React.createElement(CommentThread, { key: commentableTypeId + ":" + deviationId, currentUser: currentUser, commentableTypeId: commentableTypeId, commentableItemId: deviationId, postbox: "both", statsAndControls: "on", className: className, allowSelfInit: false, enableOffsetTracking: true })) : (React.createElement(DisabledComment, { className: classnames(s['comments-disabled'], className), title: t('deviation.comments.commentsDisabled') }))))));
};
Comments.displayName = 'Comments';
export default Comments;
//# sourceMappingURL=Comments.js.map